/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import {Api} from '../../providers/api/api';
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { CountryListForm } from './seller-model/countrylist.model';

@Injectable()
export class shippingService extends Api {
    private url: string = this.getBaseUrl();
    editData: any;
// passing manufacture editdata
setSellerEditValue(editdata) {
    this.editData = editdata;
  }

  getSellerEditeValue() {
    return this.editData;
  }

  public shippingProfileList(): Observable<any> {
    return this.http.get(this.url + '/shipping-profile/list');
  }

    public ShippingProfileAdd(params: any): Observable<any> {
        return this.http.post(this.url + '/shipping-profile/add-shipping-profile', params);
    }
    public ShippingProfileDelete(params: any): Observable<any> {
        return this.http.delete(this.url + '/shipping-profile/delete-shipping-profile/'+params);
    }
    public ShippingProfileUpdate(params: any, id : any): Observable<any> {
        return this.http.put(this.url + '/shipping-profile/update-shipping-profile/'+id, params);
    }

}

